import CreateConfiguration from './CreateConfiguration';

export default CreateConfiguration;
